module.exports = __webpack_public_path__ + "img/I+D+I_Environment.3e105f53.png";